import { render, staticRenderFns } from "./collective-purchasing-list.html?vue&type=template&id=4d8b12a3&scoped=true&external"
import script from "./collective-purchasing-list.js?vue&type=script&lang=js&external"
export * from "./collective-purchasing-list.js?vue&type=script&lang=js&external"
import style0 from "./collective-purchasing-list.scss?vue&type=style&index=0&id=4d8b12a3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b12a3",
  null
  
)

export default component.exports